// api/reasonApi.js - İade sebepleri API istekleri
import axios from 'axios';
import apiClient from './apiClient';

// Göreceli API URL'ini kullan
const API_URL = '/api';

// Axios instance oluştur
const reasonApi = axios.create({
  baseURL: `${API_URL}/reasons`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// İstek interceptor'ü - her istekte token ekle
reasonApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt interceptor'ü - hata işleme
reasonApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = 
      error.response?.data?.message || 
      error.message || 
      'Bir hata oluştu';
    
    return Promise.reject(new Error(message));
  }
);

// Tüm iade sebeplerini getir
export const getReasons = async () => {
  return await reasonApi.get('/');
};

// Belirli bir iade sebebini getir
export const getReasonById = async (id) => {
  return await reasonApi.get(`/${id}`);
};

// Yeni iade sebebi oluştur (Admin)
export const createReason = async (reasonData) => {
  return await reasonApi.post('/', reasonData);
};

// İade sebebi güncelle (Admin)
export const updateReason = async (id, reasonData) => {
  return await reasonApi.put(`/${id}`, reasonData);
};

// İade sebebi sil (Admin)
export const deleteReason = async (id) => {
  return await reasonApi.delete(`/${id}`);
};

export default reasonApi; 